export default __webpack_public_path__ + "static/media/제주.18a76496.png";